// extracted by mini-css-extract-plugin
module.exports = {"group":"userBillingSkeleton_group__pP1aO","simple":"userBillingSkeleton_simple__KfuHJ"};